const base = "w-full h-12 px-4 rounded-xl bg-white border text-[16px] text-charcoal placeholder:text-muted-moss/60 focus:outline-none focus:ring-2 focus:ring-coral/40 transition-colors";
const border = (err) => (err ? "border-red-400 bg-red-50/40" : "border-[#E3E7E2]");

export const Label = ({ children, optional }) => (
  <span className="block text-sm font-semibold text-charcoal mb-1.5">
    {children} {optional ? <span className="font-normal text-muted-moss">(opcional)</span> : <span className="text-coral">*</span>}
  </span>
);

export const TextField = ({ label, error, errorText = "Campo obligatorio", optional, testId, className = "", ...props }) => (
  <label className={`block ${className}`}>
    <Label optional={optional}>{label}</Label>
    <input data-testid={testId} className={`${base} ${border(error)}`} {...props} />
    {error && <span className="block mt-1 text-xs text-red-500">{errorText}</span>}
  </label>
);

export const SelectField = ({ label, error, options, testId, className = "", placeholder = "Selecciona…", ...props }) => (
  <label className={`block ${className}`}>
    <Label>{label}</Label>
    <select data-testid={testId} className={`${base} ${border(error)} appearance-none bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2212%22 height=%2212%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%236b7a6f%22 stroke-width=%223%22><path d=%22m6 9 6 6 6-6%22/></svg>')] bg-no-repeat bg-[right_1rem_center]`} {...props}>
      <option value="">{placeholder}</option>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        return <option key={v} value={v}>{typeof o === "string" ? o : o.label}</option>;
      })}
    </select>
    {error && <span className="block mt-1 text-xs text-red-500">Campo obligatorio</span>}
  </label>
);

export const ChoiceGroup = ({ options, value, onChange, error, testId }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button
        type="button"
        key={o.value}
        data-testid={`${testId}-${o.value}`}
        onClick={() => onChange(o.value)}
        className={`px-4 h-11 rounded-xl text-sm font-semibold border transition-colors active:scale-95 ${
          value === o.value ? "bg-coral text-white border-coral" : `bg-white text-charcoal ${error ? "border-red-400" : "border-[#E3E7E2]"} hover:bg-peach/50`
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);
